module.exports = __webpack_public_path__ + "static/media/api.3103ce12.jpg";